/**=================================================================
 * Theme Name : Kin Super Supps [Shopify]
 * Author : Mohsin Shaikh / Nikunj Patel [PM - Amruta Prajapati]
 * Description : March 2025
 * Theme : Dawn [Custom Project]
 * File Name: custom.js
==================================================================**/
ingredientsFlip();
function ingredientsFlip()
{
  const cards = document.querySelectorAll(".ingredient-product-wrapper .card");

  // Handle card "+" click
  document.querySelectorAll(".ingredient-product-wrapper .card .card-title span.card-plus").forEach(function(button) {
    button.addEventListener("click", function (e) {
      e.stopPropagation(); // Prevent outside click from triggering
      const card = this.closest(".card");

      // Reset all cards
      cards.forEach(function (all_card) {
        all_card.classList.remove("active");
        all_card.querySelector(".card-title span.card-minus").style.display = "none";
        all_card.querySelector(".card-title span.card-plus").style.display = "block";
      });

      // Activate current card
      card.classList.add("active");
      card.querySelector(".card-title span.card-plus").style.display = "none";
      card.querySelector(".card-title span.card-minus").style.display = "block";
    });
  });

  // Handle card "−" click
  document.querySelectorAll(".ingredient-product-wrapper .card .card-title span.card-minus").forEach(function(button) {
    button.addEventListener("click", function (e) {
      e.stopPropagation();
      const card = this.closest(".card");
      card.classList.remove("active");
      card.querySelector(".card-title span.card-minus").style.display = "none";
      card.querySelector(".card-title span.card-plus").style.display = "block";
    });
  });

  // Handle click outside of any card
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".ingredient-product-wrapper .card")) {
      cards.forEach(function (card) {
        card.classList.remove("active");
        card.querySelector(".card-title span.card-minus").style.display = "none";
        card.querySelector(".card-title span.card-plus").style.display = "block";
      });
    }
  });

  // Call after loading more blocks dynamically
  document.querySelectorAll('.flip-block').forEach(block => {
    block.replaceWith(block.cloneNode(true)); // removes old listeners
  });
document.querySelectorAll('.flip-block').forEach(block => {
  const inner = block.querySelector('.flip-inner');
  const front = block.querySelector('.flip-front');
  const back = block.querySelector('.flip-back');
  
  // Function to set height on mobile
  function updateAllHeights() {
    document.querySelectorAll('.flip-block').forEach(b => {
      const i = b.querySelector('.flip-inner');
      const f = b.querySelector('.flip-front');
      const ba = b.querySelector('.flip-back');

      if (window.innerWidth <= 768) {
        if (b.classList.contains('active')) {
          i.style.height = ba.offsetHeight + 'px';
        } else {
          i.style.height = f.offsetHeight + 'px';
        }
      } else {
        i.style.height = ''; // Desktop natural height
      }
    });
  }
 
   // Initialize heights
  updateAllHeights();

  // Toggle buttons on front/back
  block.querySelectorAll('.flip-toggle').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();

      const isActive = block.classList.contains('active');

      // Close all other flip-blocks on mobile
      //if (window.innerWidth <= 768) {
        document.querySelectorAll('.flip-block').forEach(b => b.classList.remove('active'));
      //}

      // Toggle current
      if (!isActive) {
        block.classList.add('active');
      } else {
        block.classList.remove('active');
      }

      // Update height after toggle
      updateAllHeights();
    });
  });

  // Update height on resize
  window.addEventListener('resize', updateAllHeights);
});

}
const menuHeaders = document.querySelectorAll(".footer-block--menu h2");
menuHeaders.forEach(function(header) {
  header.addEventListener("click", function () {
    const parentMenu = header.closest(".footer-block--menu");
    const targetUl = parentMenu.querySelector("ul");

    if (targetUl) {
      targetUl.classList.toggle("active"); // You can define `.active` in CSS
    }
  });
});
document.querySelectorAll('header-drawer .arrow, header-drawer .cst-no-click2').forEach(arrow => {
  arrow.addEventListener('click', function(event) {
    event.stopPropagation();

    const parentLi = this.closest('li');
    const isActive = parentLi.classList.contains('show-sub');

    // Determine submenu level
    const submenuLevelClass = parentLi.classList.contains('has-submenu-2')
      ? '.has-submenu-2'
      : '.has-submenu-1';

    // Remove 'active' from all items at the same level
    document.querySelectorAll(submenuLevelClass).forEach(li => {
      li.classList.remove('show-sub');
    });

    // Toggle active class on clicked parent <li>
    if (!isActive) {
      parentLi.classList.add('show-sub');
    }
  });
});
document.addEventListener('DOMContentLoaded', function() {
  var toggles = document.querySelectorAll('.custom-faq-js .accordion-toggle');
  var contents = document.querySelectorAll('.custom-faq-js .accordion-content');

  toggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var content = this.nextElementSibling;
      var isOpen = content.classList.contains('open');

      // Close all
      contents.forEach(function(c) {
        if (c.classList.contains('open')) {
          // Set height to current for transition
          c.style.height = c.scrollHeight + 'px';
          // Force reflow
          void c.offsetHeight;
          c.style.height = '0px';
          c.classList.remove('open');
        }
      });
      toggles.forEach(function(t) {
        t.classList.remove('active');
        t.setAttribute('aria-expanded', 'false');
      });

      // Open current if not already open
      if (!isOpen) {
        content.classList.add('open');
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
        content.style.height = content.scrollHeight + 'px';
      }
    });

    // Keyboard accessibility
    toggle.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // After transition, set height to auto if open, or keep at 0 if closed
  contents.forEach(function(content) {
    content.addEventListener('transitionend', function() {
      if (content.classList.contains('open')) {
        content.style.height = 'auto';
      }
    });
  });
});
document.addEventListener('rebuy:cart.change', function (event) {
  const Cart = event.detail.cart;
  const cartCountElement = document.querySelector('.cart-count-bubble');
  
  if (cartCountElement && Cart.cart.item_count === 0) {
    cartCountElement.style.visibility = "hidden";
  } else if(cartCountElement) {
    cartCountElement.style.visibility = "visible";
  }
});
document.addEventListener('rebuy:smartcart.ready', (event) => {
    var po = document.createElement('script');
    po.type = 'text/javascript';
    po.async = false;
    po.src = 'https://cdn.judge.me/loader.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(po, s);
});

// $(document).ready(function(){
//   $(".toggle-header").click(function(){
//     $(".all-options").slideToggle();
//   });
// });

function equalizeHeights() {
  const blocks = Array.from(document.querySelectorAll('.flip-block'));

  // Reset all heights first
  blocks.forEach(block => {
    const front = block.querySelector('.flip-front');
    const back = block.querySelector('.flip-back');
    const inner = block.querySelector('.flip-inner');

    front.style.height = '';
    back.style.height = '';
    inner.style.height = '';
  });

  // Desktop: no fixed heights (let load more or content control it)
  if (window.innerWidth > 768) return;

  // Mobile: optional, set height to match currently visible face if needed
  blocks.forEach(block => {
    const inner = block.querySelector('.flip-inner');
    const front = block.querySelector('.flip-front');
    const back = block.querySelector('.flip-back');

    if (block.classList.contains('active') || block.classList.contains('flipped')) {
      inner.style.height = back.offsetHeight + 'px';
    } else {
      inner.style.height = front.offsetHeight + 'px';
    }
  });
}

